import {
  DisplayableError,
  useDisplayableError,
} from "kreate-common/modules/displayable-error";
import { httpGet$GetArtworkList } from "kreate-server/commands/GetArtworkList/fetcher";
import {
  GetArtworkList$Params,
  GetArtworkList$Result,
} from "kreate-server/commands/GetArtworkList/typing";
import useSWR from "swr";

export function useArtworkList(
  params: GetArtworkList$Params | undefined
): [GetArtworkList$Result | undefined, DisplayableError | undefined] {
  const { data, error } = useSWR(
    params ? ["10a0782b-c3a2-4d7e-871a-cd316e49ea51", params] : undefined,
    async () =>
      params
        ? await httpGet$GetArtworkList("/api/v1/all-artworks/list", params)
        : undefined
  );

  const displayableError = useDisplayableError(
    error,
    "Failed to fetch artwork list"
  );

  return [data, displayableError];
}
